import React from "react";

import { BaseComponent } from "../../utils/BaseComponent";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/admin-endpoint";
import { ds } from "../../DataSource";
import { ROUTER_HOME } from "../home/Router";

import moment from "moment";

interface AgreementListState {
    datasource: {
        List: ParentStateDatasource<typeof Endpoint.Agreement.GetAgreementList>;
    };
}

class AgreementList extends BaseComponent<RouteComponentProps, AgreementListState> {
    state: AgreementListState = {
        datasource: {
            List: DataSourceStateIdle
        }
    };

    private dsList = ds(Endpoint.Agreement.GetAgreementList, this, "List", () => this.context);

    componentDidMount() {
        this.getList();
    }

    render() {
        return (
            <div className="page">
                <div className="page__header">Lista Zgód</div>
                <div className="page-buttons">
                    <Link to={ROUTER_HOME.Agreement.Add} className="button small">
                        Dodaj zgodę
                    </Link>
                </div>
                <div className="page-table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="w-4 t-left">Nazwa</th>
                                <th className="w-4">Data dodania</th>
                                <th className="w-2">Aktywna</th>
                                <th className="w-2">Wymagana</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.agreementList.map(agreement => (
                                <tr
                                    className="clickable"
                                    key={agreement.AgreementId}
                                    onClick={() =>
                                        this.props.history.push({
                                            pathname: ROUTER_HOME.Agreement.Details,
                                            search: `AgreementId=${agreement.AgreementId}`
                                        })
                                    }
                                >
                                    <td className="t-left">{agreement.Name}</td>
                                    <td>{moment(agreement.CreatedAt).format("YYYY-MM-DD")}</td>
                                    <td>{agreement.IsActive ? "TAK" : "-"}</td>
                                    <td>{agreement.IsRequired ? "TAK" : "-"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get agreementList() {
        const dsListData = this.dsList.dataSourceStorage;
        if (dsListData.state === "completed") {
            return dsListData.response.agreements;
        }
        return [];
    }

    get overlayProps(): OverlayProps {
        if (this.dsList.state === "pending" || this.dsList.state === "idle") {
            return {
                show: true,
                title: "Ładowanie..."
            };
        }
        if (this.dsList.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                children: (
                    <div className="overlay__children">
                        <button onClick={() => this.getList()} className="button light">
                            Spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private getList() {
        this.dsList.request({});
    }
}

export default withRouter(AgreementList);
